module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-07.d63bd905.svg";